// @ts-nocheck

export const localeCodes =  [
  "ar-EG",
  "az-AZ",
  "bg-BG",
  "bn-IN",
  "cs-CZ",
  "de-DE",
  "en-GB",
  "en-US",
  "es-419",
  "es-ES",
  "fr-FR",
  "hi-IN",
  "hu-HU",
  "id-ID",
  "it-IT",
  "ja-JP",
  "kn-IN",
  "mr-IN",
  "nb-NO",
  "ne-NP",
  "pl-PL",
  "pt-BR",
  "ru-RU",
  "ta-IN",
  "te-IN",
  "tr-TR",
  "uk-UA",
  "zh-CN",
  "zh-TW"
]
export const localeLoaders = {
  "ar-EG": [
    {
      key: "locale_ar_46json_802c0f8d",
      load: () => import("#nuxt-i18n/802c0f8d" /* webpackChunkName: "locale_ar_46json_802c0f8d" */),
      cache: true
    },
    {
      key: "locale_ar_45EG_46json_24811d98",
      load: () => import("#nuxt-i18n/24811d98" /* webpackChunkName: "locale_ar_45EG_46json_24811d98" */),
      cache: true
    }
  ],
  "az-AZ": [
    {
      key: "locale_az_45AZ_46json_20655060",
      load: () => import("#nuxt-i18n/20655060" /* webpackChunkName: "locale_az_45AZ_46json_20655060" */),
      cache: true
    }
  ],
  "bg-BG": [
    {
      key: "locale_bg_45BG_46json_16873415",
      load: () => import("#nuxt-i18n/16873415" /* webpackChunkName: "locale_bg_45BG_46json_16873415" */),
      cache: true
    }
  ],
  "bn-IN": [
    {
      key: "locale_bn_45IN_46json_efd88f49",
      load: () => import("#nuxt-i18n/efd88f49" /* webpackChunkName: "locale_bn_45IN_46json_efd88f49" */),
      cache: true
    }
  ],
  "cs-CZ": [
    {
      key: "locale_cs_45CZ_46json_94e47fb8",
      load: () => import("#nuxt-i18n/94e47fb8" /* webpackChunkName: "locale_cs_45CZ_46json_94e47fb8" */),
      cache: true
    }
  ],
  "de-DE": [
    {
      key: "locale_de_45DE_46json_57c1d881",
      load: () => import("#nuxt-i18n/57c1d881" /* webpackChunkName: "locale_de_45DE_46json_57c1d881" */),
      cache: true
    }
  ],
  "en-GB": [
    {
      key: "locale_en_46json_56e4bbcf",
      load: () => import("#nuxt-i18n/56e4bbcf" /* webpackChunkName: "locale_en_46json_56e4bbcf" */),
      cache: true
    },
    {
      key: "locale_en_45GB_46json_deddeb14",
      load: () => import("#nuxt-i18n/deddeb14" /* webpackChunkName: "locale_en_45GB_46json_deddeb14" */),
      cache: true
    }
  ],
  "en-US": [
    {
      key: "locale_en_46json_56e4bbcf",
      load: () => import("#nuxt-i18n/56e4bbcf" /* webpackChunkName: "locale_en_46json_56e4bbcf" */),
      cache: true
    },
    {
      key: "locale_en_45US_46json_2524cf10",
      load: () => import("#nuxt-i18n/2524cf10" /* webpackChunkName: "locale_en_45US_46json_2524cf10" */),
      cache: true
    }
  ],
  "es-419": [
    {
      key: "locale_es_46json_8e4da0ca",
      load: () => import("#nuxt-i18n/8e4da0ca" /* webpackChunkName: "locale_es_46json_8e4da0ca" */),
      cache: true
    },
    {
      key: "locale_es_45419_46json_6ac81e7d",
      load: () => import("#nuxt-i18n/6ac81e7d" /* webpackChunkName: "locale_es_45419_46json_6ac81e7d" */),
      cache: true
    }
  ],
  "es-ES": [
    {
      key: "locale_es_46json_8e4da0ca",
      load: () => import("#nuxt-i18n/8e4da0ca" /* webpackChunkName: "locale_es_46json_8e4da0ca" */),
      cache: true
    },
    {
      key: "locale_es_45ES_46json_6823c46d",
      load: () => import("#nuxt-i18n/6823c46d" /* webpackChunkName: "locale_es_45ES_46json_6823c46d" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_45FR_46json_fc78611c",
      load: () => import("#nuxt-i18n/fc78611c" /* webpackChunkName: "locale_fr_45FR_46json_fc78611c" */),
      cache: true
    }
  ],
  "hi-IN": [
    {
      key: "locale_hi_45IN_46json_a307dfe6",
      load: () => import("#nuxt-i18n/a307dfe6" /* webpackChunkName: "locale_hi_45IN_46json_a307dfe6" */),
      cache: true
    }
  ],
  "hu-HU": [
    {
      key: "locale_hu_45HU_46json_aecbe4e0",
      load: () => import("#nuxt-i18n/aecbe4e0" /* webpackChunkName: "locale_hu_45HU_46json_aecbe4e0" */),
      cache: true
    }
  ],
  "id-ID": [
    {
      key: "locale_id_45ID_46json_8f04e18b",
      load: () => import("#nuxt-i18n/8f04e18b" /* webpackChunkName: "locale_id_45ID_46json_8f04e18b" */),
      cache: true
    }
  ],
  "it-IT": [
    {
      key: "locale_it_45IT_46json_6c059c8c",
      load: () => import("#nuxt-i18n/6c059c8c" /* webpackChunkName: "locale_it_45IT_46json_6c059c8c" */),
      cache: true
    }
  ],
  "ja-JP": [
    {
      key: "locale_ja_45JP_46json_be60d303",
      load: () => import("#nuxt-i18n/be60d303" /* webpackChunkName: "locale_ja_45JP_46json_be60d303" */),
      cache: true
    }
  ],
  "kn-IN": [
    {
      key: "locale_kn_45IN_46json_021d0a99",
      load: () => import("#nuxt-i18n/021d0a99" /* webpackChunkName: "locale_kn_45IN_46json_021d0a99" */),
      cache: true
    }
  ],
  "mr-IN": [
    {
      key: "locale_mr_45IN_46json_4a4281dc",
      load: () => import("#nuxt-i18n/4a4281dc" /* webpackChunkName: "locale_mr_45IN_46json_4a4281dc" */),
      cache: true
    }
  ],
  "nb-NO": [
    {
      key: "locale_nb_45NO_46json_cd181f4c",
      load: () => import("#nuxt-i18n/cd181f4c" /* webpackChunkName: "locale_nb_45NO_46json_cd181f4c" */),
      cache: true
    }
  ],
  "ne-NP": [
    {
      key: "locale_ne_45NP_46json_0a505166",
      load: () => import("#nuxt-i18n/0a505166" /* webpackChunkName: "locale_ne_45NP_46json_0a505166" */),
      cache: true
    }
  ],
  "pl-PL": [
    {
      key: "locale_pl_45PL_46json_eb31a0df",
      load: () => import("#nuxt-i18n/eb31a0df" /* webpackChunkName: "locale_pl_45PL_46json_eb31a0df" */),
      cache: true
    }
  ],
  "pt-BR": [
    {
      key: "locale_pt_45BR_46json_fb642719",
      load: () => import("#nuxt-i18n/fb642719" /* webpackChunkName: "locale_pt_45BR_46json_fb642719" */),
      cache: true
    }
  ],
  "ru-RU": [
    {
      key: "locale_ru_45RU_46json_dfac9300",
      load: () => import("#nuxt-i18n/dfac9300" /* webpackChunkName: "locale_ru_45RU_46json_dfac9300" */),
      cache: true
    }
  ],
  "ta-IN": [
    {
      key: "locale_ta_45IN_46json_c4dfdca2",
      load: () => import("#nuxt-i18n/c4dfdca2" /* webpackChunkName: "locale_ta_45IN_46json_c4dfdca2" */),
      cache: true
    }
  ],
  "te-IN": [
    {
      key: "locale_te_45IN_46json_7714ca19",
      load: () => import("#nuxt-i18n/7714ca19" /* webpackChunkName: "locale_te_45IN_46json_7714ca19" */),
      cache: true
    }
  ],
  "tr-TR": [
    {
      key: "locale_tr_45TR_46json_ffb37b7f",
      load: () => import("#nuxt-i18n/ffb37b7f" /* webpackChunkName: "locale_tr_45TR_46json_ffb37b7f" */),
      cache: true
    }
  ],
  "uk-UA": [
    {
      key: "locale_uk_45UA_46json_3b4a4487",
      load: () => import("#nuxt-i18n/3b4a4487" /* webpackChunkName: "locale_uk_45UA_46json_3b4a4487" */),
      cache: true
    }
  ],
  "zh-CN": [
    {
      key: "locale_zh_45CN_46json_1c143cc4",
      load: () => import("#nuxt-i18n/1c143cc4" /* webpackChunkName: "locale_zh_45CN_46json_1c143cc4" */),
      cache: true
    }
  ],
  "zh-TW": [
    {
      key: "locale_zh_45TW_46json_0e570f0e",
      load: () => import("#nuxt-i18n/0e570f0e" /* webpackChunkName: "locale_zh_45TW_46json_0e570f0e" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/5458581c" /* webpackChunkName: "config_i18n_46config_46ts_5458581c" */)
]
export const normalizedLocales = [
  {
    code: "ar-EG",
    name: "العربية",
    dir: "rtl",
    language: undefined
  },
  {
    code: "az-AZ",
    name: "Azərbaycanca",
    language: undefined
  },
  {
    code: "bg-BG",
    name: "Български",
    language: undefined
  },
  {
    code: "bn-IN",
    name: "বাংলা",
    language: undefined
  },
  {
    code: "cs-CZ",
    name: "Čeština",
    language: undefined
  },
  {
    code: "de-DE",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "en-GB",
    name: "English (UK)",
    language: undefined
  },
  {
    code: "en-US",
    name: "English (US)",
    language: undefined
  },
  {
    code: "es-419",
    name: "Español (Latinoamérica)",
    language: undefined
  },
  {
    code: "es-ES",
    name: "Español (España)",
    language: undefined
  },
  {
    code: "fr-FR",
    name: "Français",
    language: undefined
  },
  {
    code: "hi-IN",
    name: "हिंदी",
    language: undefined
  },
  {
    code: "hu-HU",
    name: "Magyar",
    language: undefined
  },
  {
    code: "id-ID",
    name: "Indonesia",
    language: undefined
  },
  {
    code: "it-IT",
    name: "Italiano",
    language: undefined
  },
  {
    code: "ja-JP",
    name: "日本語",
    language: undefined
  },
  {
    code: "kn-IN",
    name: "ಕನ್ನಡ",
    language: undefined
  },
  {
    code: "mr-IN",
    name: "मराठी",
    language: undefined
  },
  {
    code: "nb-NO",
    name: "Norsk (Bokmål)",
    language: undefined
  },
  {
    code: "ne-NP",
    name: "नेपाली",
    language: undefined
  },
  {
    code: "pl-PL",
    name: "Polski",
    language: undefined
  },
  {
    code: "pt-BR",
    name: "Português (Brasil)",
    language: undefined
  },
  {
    code: "ru-RU",
    name: "Русский",
    language: undefined
  },
  {
    code: "ta-IN",
    name: "தமிழ்",
    language: undefined
  },
  {
    code: "te-IN",
    name: "తెలుగు",
    language: undefined
  },
  {
    code: "tr-TR",
    name: "Türkçe",
    language: undefined
  },
  {
    code: "uk-UA",
    name: "Українська",
    language: undefined
  },
  {
    code: "zh-CN",
    name: "简体中文",
    language: undefined
  },
  {
    code: "zh-TW",
    name: "繁體中文",
    language: undefined
  }
]

